import { Alert } from 'react-bootstrap'
import React from 'react'

type NoMicPermissionProps = {
  errorType: string
  errorMessage: string
}

export const NoMicPermission: React.FC<NoMicPermissionProps> = ({ errorType, errorMessage }) => (
  <Alert variant='danger' className='m-0'>
    <Alert.Heading>You got an error!</Alert.Heading>
    <p>Unable to access the microphone. Please check your browser/system settings.</p>
    <p>
      {errorType} - {errorMessage}
    </p>
  </Alert>
)
